import { initSection } from '../../core/shopify/init-section/index.js';
import { isMobile } from '../../theme/responsive-utils';
const NAMESPACE = '.js-features-with-icons';
initSection(NAMESPACE, (section)=>{
    const intro = section.querySelector('.js-intro');
    const blocksEl = section.querySelector('.js-blocks');
    const blocks = blocksEl ? Array.from(blocksEl.querySelectorAll('.js-block')) : [];
    if (!intro && !blocks.length) return {
        unload: null
    };
    let blocksTriggered = false;
    let blocksTimer = null;
    const triggerAllBlocks = ()=>{
        if (blocksTriggered) return;
        blocksTriggered = true;
        blocksTimer = setTimeout(()=>{
            blocks.forEach((block, i)=>{
                block.style.setProperty('--stagger-delay', `${i * 200}ms`);
                block.classList.add('is-visible');
            });
        }, 300);
    };
    const triggerBlock = (block)=>{
        block.style.setProperty('--stagger-delay', '0ms');
        block.classList.add('is-visible');
    };
    const introObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const el = entry.target;
            if (entry.isIntersecting) {
                introObserver.unobserve(el);
                el.classList.add('is-visible');
            } else if (entry.boundingClientRect.top < 0) {
                if (!isMobile()) triggerAllBlocks();
            }
        });
    }, {
        threshold: [
            0,
            0.1
        ]
    });
    const desktopBlockObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            desktopBlockObserver.unobserve(entry.target);
            triggerAllBlocks();
        });
    }, {
        rootMargin: '0px 0px -200px 0px',
        threshold: 0
    });
    // Mobile: each block observed individually, triggers as it scrolls into view
    const mobileBlockObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            mobileBlockObserver.unobserve(entry.target);
            triggerBlock(entry.target);
        });
    }, {
        rootMargin: '0px 0px -150px 0px',
        threshold: 0
    });
    if (intro) introObserver.observe(intro);
    if (isMobile()) {
        blocks.forEach((block)=>mobileBlockObserver.observe(block));
    } else if (blocksEl) {
        desktopBlockObserver.observe(blocksEl);
    }
    return {
        unload: ()=>{
            introObserver.disconnect();
            desktopBlockObserver.disconnect();
            mobileBlockObserver.disconnect();
            if (blocksTimer !== null) clearTimeout(blocksTimer);
        }
    };
});
